import CompanyDTO from "@/dto/CompanyDTO";
import ShopType from "@/enum/ShopType";
import mainServerClient from "../http/mainServerClient";

/**获取租户信息 */
export function getCompany(id: number) {
    return mainServerClient.get<CompanyDTO>("/company/get", {
        id,
    });
}

export interface UpdateCompanyParams {
    name: string;

    sellerUsername?: string;

    shopType?: ShopType;
}

export function updateCompany(params: UpdateCompanyParams) {
    return mainServerClient.post<CompanyDTO>("/company/update", params);
}

export interface BatchGetCompanyByShopIdsReturn {
    company: CompanyDTO;

    shopId: number;
}
